module.exports = "\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/collateral-deposit/multiplier/multiplier.component.css
// module id = ./src/app/collateral-deposit/multiplier/multiplier.component.css
// module chunks = main